// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Js__Js_exn from "melange.js/js_exn.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib__Float from "melange/float.js";

function decode(now, json) {
  try {
    if (Mapre_wire__Json.string(json, "status") !== "authorization_pending") {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_login_status"
        });
    }
    const url = Mapre_wire__Json.string(json, "login_url");
    const parsed = new URL(url);
    if (url.length > 4096 || parsed.protocol !== "https:" || parsed.hostname === "" || parsed.username !== "" || parsed.password !== "") {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_login_url"
        });
    }
    const value = Js__Js_json.decodeNumber(Mapre_wire__Json.get(json, "expires_at"));
    let expires_at;
    if (value !== undefined) {
      if (Stdlib__Float.is_finite(value) && value > now) {
        expires_at = value;
      } else {
        throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
            MEL_EXN_ID: Mapre_wire__Json.Invalid,
            _1: "invalid_login_expiry"
          });
      }
    } else {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_login_expiry"
        });
    }
    const value$1 = Mapre_wire__Json.get(json, "user_code");
    let user_code;
    if (Caml_obj.caml_equal(value$1, null)) {
      user_code = undefined;
    } else {
      const code = Js__Js_json.decodeString(value$1);
      if (code !== undefined) {
        if (code !== "" && code.length <= 128) {
          user_code = code;
        } else {
          throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
              MEL_EXN_ID: Mapre_wire__Json.Invalid,
              _1: "invalid_login_code"
            });
        }
      } else {
        throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
            MEL_EXN_ID: Mapre_wire__Json.Invalid,
            _1: "invalid_login_code"
          });
      }
    }
    return {
      url,
      user_code,
      expires_at
    };
  }
  catch (raw_exn){
    const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.MEL_EXN_ID === Js__Js_exn.$$Error) {
      throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
          MEL_EXN_ID: Mapre_wire__Json.Invalid,
          _1: "invalid_login_url"
        });
    }
    throw exn;
  }
}

export {
  decode,
}
/* Js__Js_exn Not a pure module */
